<template>
  <div class="troughdose">
    <h2 class="title">Trough - based dosing</h2>
    <ul id="input">
      <li>
        <input type="radio" v-model="sex" value="male"> male
        <input type="radio" v-model="sex" value="female"> female
      </li>

      <li>
        TBW
        <input class="input" type="integer" v-model="tbw" size="3px"> kg
      </li>

      <li>
        Height
        <input class="input" type="integer" v-model="ht" size="3px">
        cm [BMI {{bmicalc()}}]
      </li>

      <li>
        Age
        <input class="input" type="integer" v-model="age" size="3px">
        years
      </li>

      <li>
        SCr
        <input class="input" type="integer" v-model="scr" size="4px">
        mg/dl
      </li>
      <li>
        <input type="radio" v-model="crcluse" value="modified">
        CrCl {{crclcalc.toFixed(0)}} ml/min (modified Cockcroft-Gault)
      </li>
      <li>
        <input type="radio" v-model="crcluse" value="original">
        CrCl {{crclcalcoriginal.toFixed(0)}} ml/min (Cockcroft-Gault)
      </li>
      <li>
        <input type="radio" v-model="crcluse" value="manual">
        CrCl manual
        <input class="input" type="integer" v-model="crclman" size="3px">
        ml/min
      </li>
    </ul>

    <div id="dose">
      Maintenance Dose
      <br>
      <img src="../assets/ivdrip.png" height="40px">
      {{dosecalc}}
    </div>
    <div id="warning">Maxdose 2 g/dose 4.5g/day (รวม loading dose)</div>
    <b-form-checkbox v-model="ldchecked" name="check-button" switch><b>Loading dose</b></b-form-checkbox>
    <div v-show="ldchecked===true">
      <div id="lddose">
        Standard loading dose {{ldstandard}} (~25 mg/kg)
        <br>
        Modified loading dose** {{ldmodified}} (20 - 25 mg/kg)
      </div>
      <br>
      {{msg}}
      <ul id="warning">
        <li>ให้ Loading dose เมื่อต้องการให้ระดับยาถึงเป้าหมายตั้งแต่วันแรก (AUC/MIC of >400 mcg-h/mL)</li>
        <li>การเลือกใช้ขนาดยาให้พิจารณาจากความรุนแรงของการติดเชื้อ และความเร่งด่วนในการให้ระดับยาถึงเป้าหมาย ไม่ควรพิจารณาเพียงขนาดตัวของผู้ป่วยอย่างเดียว</li>
        <li>ระยะห่างระหว่าง Loading dose กับ maintenance dose เท่ากับ 12 – 24 ชั่วโมง ขึ้นกับ renal function ของผู้ป่วย</li>
      </ul>
    </div>
    <h2 class="title">CRRT</h2>TBW
    <input type="range" min="35" max="120" step="1" v-model="tbw">
    <input class="input" type="integer" v-model="tbw" size="3px"> kg
    <div>
      Initial Dose: {{crrtinitdosecalc}} (Maxdose 2 g)
      <br>
      Maintenance Dose: {{crrtmdcalc}}
    </div>
    <h2 class="title">Peritoneal dialysis</h2>TBW
    <input type="range" min="35" max="120" step="1" v-model="tbw">
    <input class="input" type="integer" v-model="tbw" size="3px"> kg
    <div>{{pddosecalc}}</div>
  </div>
</template>

<script>
export default {
  name: "troughdose",

  data() {
    return {
      tbw: 60,
      ht: 150,
      age: 30,
      scr: 0.9,
      crclman: 100,
      crcluse: "modified",
      aucgoal: 400,
      sex: "male",
      ldchecked: false,
      ldtype: "standard",
      msg:
        "**ผู้ป่วยที่มี BMI > 30, CrCl < 30, AKI, IHD, CRRT หรือผู้ป่วยที่ไม่มีค่า SCr (ผู้ป่วยฉุกเฉินจำเป็นต้องให้ยาทันที) "
    };
  },
  methods: {
    vdcalc() {
      return (0.7 * this.tbw).toFixed(1);
    },
    abwcalc() {
      return this.ibwcalc() + 0.4 * (this.tbw - this.ibwcalc());
    },
    bmicalc() {
      return Math.round(this.tbw / Math.pow(this.ht / 100, 2));
    },
    wtforcrclcalc() {
      if (this.bmicalc() >= 25) {
        return this.abwcalc();
      } else if (this.bmicalc() > 18.5) {
        return this.ibwcalc();
      } else {
        return this.tbw;
      }
    },
    ibwcalc() {
      if (this.sex === "male") {
        return 50 + 2.3 * (this.ht / 2.54 - 60);
      } else {
        return 45.5 + 2.3 * (this.ht / 2.54 - 60);
      }
    },
    kecalc() {
      return (0.00083 * this.crcl + 0.0044).toFixed(4);
    },
    clvancoobesecalc() {
      if (this.sex === "female") {
        return (
          9.656 -
          0.078 * this.age -
          2.009 * this.scr +
          0.04 * Math.pow(this.tbw, 0.75)
        );
      } else {
        return (
          9.656 -
          0.078 * this.age -
          2.009 * this.scr +
          1.09 +
          0.04 * Math.pow(this.tbw, 0.75)
        );
      }
    }
  },
  computed: {
    ldcalc() {
      if (this.ldtype === "standard") {
        return this.ldstandard;
      } else {
        return this.ldmodified;
      }
    },
    ldstandard() {
      if (this.tbw > 120) {
        return "2,000 - 3,000 mg";
      } else if (this.tbw >= 76) {
        return "2,000 mg";
      } else if (this.tbw >= 66) {
        return "1,750 mg";
      } else if (this.tbw >= 56) {
        return "1,500 mg";
      } else if (this.tbw >= 46) {
        return "1,250 mg";
      } else if (this.tbw >= 36) {
        return "1,000 mg";
      } else {
        return this.tbw * 25 + " mg";
      }
    },
    ldmodified() {
      if (this.tbw > 120) {
        return "2,000 mg";
      } else if (this.tbw >= 76) {
        return "1,750 mg";
      } else if (this.tbw >= 66) {
        return "1,500 mg";
      } else if (this.tbw >= 56) {
        return "1,250 mg";
      } else if (this.tbw >= 46) {
        return "1,000 mg";
      } else if (this.tbw >= 36) {
        return "750 mg";
      } else {
        return this.tbw * 20 + " mg";
      }
    },
    crclcalc() {
      if (this.sex === "male") {
        return ((140 - this.age) * this.wtforcrclcalc()) / (72 * this.scr);
      } else {
        return (
          ((140 - this.age) * (this.wtforcrclcalc() * 0.85)) / (72 * this.scr)
        );
      }
    },
    crcl() {
      if (this.crcluse === "modified") {
        return this.crclcalc.toFixed(0);
      } else if (this.crcluse === "original") {
        return this.crclcalcoriginal.toFixed(0);
      } else {
        return this.crclman;
      }
    },
    crclcalcoriginal() {
      if (this.sex === "male") {
        return ((140 - this.age) * this.tbw) / (72 * this.scr);
      } else {
        return ((140 - this.age) * (this.tbw * 0.85)) / (72 * this.scr);
      }
    },
    hlcalc() {
      return Math.round(0.693 / this.kecalc());
    },
    clvancocalc() {
      return (this.kecalc() * 0.7 * this.tbw).toFixed(4);
    },
    clvancocalc2() {
      return ((this.crcl * 0.79 + 15.4) * 0.06).toFixed(4);
    },
    dosecalc() {
      if (this.crcl > 90) {
        return Math.round((this.tbw * 15) / 100) * 100 + " mg q8-12 hr";
      } else if (this.crcl >= 51) {
        return (
          Math.round((this.tbw * 10) / 100) * 100 +
          " - " +
          Math.round((this.tbw * 20) / 100) * 100 +
          " mg q12 hr"
        );
      } else if (this.crcl >= 30) {
        return (
          Math.round((this.tbw * 10) / 100) * 100 +
          " - " +
          Math.round((this.tbw * 15) / 100) * 100 +
          " mg q12 hr หรือ " +
          Math.round((this.tbw * 20) / 100) * 100 +
          " mg q24 hr "
        );
      } else if (this.crcl >= 10) {
        return (
          Math.round((this.tbw * 10) / 100) * 100 +
          " - " +
          Math.round((this.tbw * 15) / 100) * 100 +
          " mg q24 hr หรือ " +
          Math.round((this.tbw * 15) / 100) * 100 +
          " mg q48 hr "
        );
      } else {
        return this.tbw * 15 + " mg x 1 then dose by level";
      }
    },
    crrtinitdosecalc() {
      return (
        Math.round((this.tbw * 20) / 100) * 100 +
        " - " +
        Math.round((this.tbw * 25) / 100) * 100 +
        " mg x 1"
      );
    },
    crrtmdcalc() {
      return (
        Math.round((this.tbw * 10) / 100) * 100 +
        " - " +
        Math.round((this.tbw * 15) / 100) * 100 +
        " mg q24 hr"
      );
    },
    pddosecalc() {
      return (
        Math.round((this.tbw * 10) / 100) * 100 +
        " - " +
        Math.round((this.tbw * 15) / 100) * 100 +
        " mg IV x 1 then dose by level"
      );
    }
  }
};
</script>

<style scope >
div {
  margin-top: 10px;
}
ul#input li {
  display: list-item;
  list-style-type: none;
}
span#dose {
  font-size: 25px;
  color: #4f9bb2;
  background-color: #fccbcb;
}
div#dose {
  font-size: 25px;
  color: black;
  background-color: #fccbcb;
}
div#lddose {
  font-size: 20px;
  color: black;
  background-color: #fccbcb;
}


.input {
  font-size: 20px;
  font-weight: bold;
  text-align: center;
  color: #364f6b;
  border-top: none;
  border-left: none;
  border-right: none;
  border-bottom: 1px thin #4f9bb2;
}
</style>